<template>
  <div class="container contents yuukyuu-kanri-detail">
    <h2>年次有給休暇個人別管理台帳</h2>

    <template v-if="isLoading">
      <loading :isLoading="isLoading" :message="'読み込み中...'"></loading>
    </template>
    <div v-if="!isLoading">
      <div class="baseinfo">

        <template v-if="options.length == 0">
          <div class="container btn-link">
            <button type="button" class="btn primary" @click="toNew">新規追加</button>
          </div>
        </template>

        <div class="col-item"><b>社員番号</b><span>{{ daichouInfo?.staff_code }}</span></div>
        <div class="col-item"><b>氏名</b><span>{{ daichouInfo?.staff_name }}</span></div>
        <div class="col-item"><b>対応期間</b><span v-show="isFuyo">{{ daichouInfo?.start_date }} ～ {{ daichouInfo?.end_date }}</span></div>
        <div class="col-item">
          <div>
            <template v-if="isInitLoading">
              <loading :isLoading="isInitLoading" :message="'読み込み中...'"></loading>
            </template>
            <template v-if="!isInitLoading">
              <b>付与日を選択</b>
              <select-box :options="options" v-model="selectedPeriod" :hasBlank="false"></select-box>
              <button type="button" class="btn primary" @click="changeFuyobi">選択した付与日の情報を表示</button>
            </template>
          </div>
        </div>
      </div>
      <div class="fuyo-table">
        <table>
          <tbody>
            <tr>
              <td class="title">前年度繰越日数</td>
              <td>{{ daichouInfo?.zennen_kurikoshi_days }}</td>
              <td colspan="5">日</td>
            </tr>
            <tr>
              <td class="title">今年度付与日数</td>
              <td class="edit">
                <span>{{ daichouInfo?.konnen_fuyo_days }}</span>
              </td>
              <td>日</td>
              <td>
                <!-- NOT編集 -->
                <!-- <template v-if="!disableFlg"> -->
                  <div class="flex-container fuyo-not-edit" @click="openFuyoSyuuseiDialog(daichouInfo)" v-show="isFuyo">
                    <i class="fa-solid fa-pen btn-edit"></i>
                  </div>
                <!-- </template> -->
              </td>
            </tr>
            <tr>
              <td class="title">特別有給</td>
              <td>{{ daichouInfo?.tokubetsu_kyuuka }}</td>
              <td>日</td>
              <td>
                <div class="flex-container fuyo-not-edit" @click="openFuyoSyuuseiDialog(daichouInfo)" v-show="isFuyo">
                  <i class="fa-solid fa-pen btn-edit"></i>
                </div>
              </td>
            </tr>
            <tr>
              <td class="title">合計</td>
              <td>{{ daichouInfo?.yuukyuu_total }}</td>
              <td colspan="5">日分</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="syutoku-status-table">
        <p class="ttile weight">有給休暇取得状況</p>
        <scroll-table>
          <template v-if="isListLoading">
            <loading :isLoading="isListLoading" :message="'読み込み中...'"></loading>
          </template>
          <table v-if="!isListLoading">
            <thead>
              <tr>
                <th>日付</th>
                <th>AM/PM</th>
                <th>前年分使用日数</th>
                <th>今年分使用日数</th>
                <th>残日数</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(item, index) in syutokuList" :key="index">
                  <tr>
                    <td>{{ dateFormat(item.yuukyuu_syutoku_date) }}</td>
                    <td>{{ item.yuukyuu_tani_type_str }}</td>
                    <td>{{ item.zennenShiyouDays }}</td>
                    <td>{{ item.konnenShiyouDays }}</td>
                    <td>{{ item.zanDays }}</td>
                  </tr>
              </template>
            </tbody>
          </table>
        </scroll-table>
      </div>
    </div>

    <modal :title="fuyoSyuuseiModalParts.title" ref="fuyoSyuuseiModalRef">
      <dialog-fuyo-syuusei :userId="userId" :syuuseiData="syuuseiData" @cancel="canceldFuyoSyuusei" @close="closedFuyoSyuusei">
      </dialog-fuyo-syuusei>
    </modal>

    <div class="button-container">
      <p class="prev-page">
        <a @click="router.go(-1)">戻る</a>
      </p>
    </div>
    <!--button-container-->
  </div>
  <!--contents-->
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, computed } from "vue";
import { useInit } from "@/composable/yuukyuu/detail/init";
import { useList } from "@/composable/yuukyuu/detail/list";
import { useInfo } from "@/composable/yuukyuu/detail/info";
import { dateFormat } from "@/filters/common"
import { RouterConst } from "@/const/Router";
import { useFuyoSyuuseiModal } from '@/composable/modal/fuyo-syuusei'
import OptionConst from '@/const/Option';
import FuyoSyuusei from "@/components/yuukyuukanri/FuyoSyuusei.vue"
import dayjs from "dayjs";
import { useRouter } from 'vue-router';
import { DialogService } from '@/service/DialogService';
import { GetDaichouInfoRes } from "@/types/YuukyuuKanri";
import { BaseOption } from "@/types/Option";

export default defineComponent({
  setup() {
    const editFuyoDays = ref()
    const userId = ref()
    const fuyoDate = ref<string | null>(null)
    const options = ref<BaseOption[]>([]);
    const selectedPeriod = ref();
    const disableFlg = ref(false);

    const { daichouInfo, code, syutokuList, isInitLoading, getFuyobiOptions } = useInit()
    const { getDaichouInfo, isLoading, getPastDaichouInfo } = useInfo()
    const { getKyukaList, isListLoading, deleteYuukyuu } = useList()
    const router = useRouter()
    const fuyoSyuuseiModal = useFuyoSyuuseiModal()

    // 初期化処理
    onMounted(async () => {

      // 詳細取得
      daichouInfo.value = await getDaichouInfo(code)
      if(daichouInfo.value){
        const info = daichouInfo.value
        let start = null
        let end = null

        userId.value = info.user_id
        fuyoDate.value = info?.this_year_fuyo_date

        userId.value = info.user_id
        if(fuyoDate.value){
          start = dayjs(fuyoDate.value).format('YYYY/MM/DD')
          end = dayjs(fuyoDate.value).add(1, 'y').subtract(1, 'd').format('YYYY/MM/DD')
        }

        // 有給休暇リスト取得
        syutokuList.value = await getKyukaList(code, start, end, info.konnen_fuyo_days, info.zennen_kurikoshi_days, info.tokubetsu_kyuuka);

        await getFuyobiOptions(userId.value, options);
      }
    });

    const isFuyo = computed(() => {
      return daichouInfo.value?.start_date
    })

    // ダイアログ表示
    const openFuyoSyuuseiDialog = async (val: GetDaichouInfoRes) => {
      await fuyoSyuuseiModal.setData(val)
      fuyoSyuuseiModal.openFuyoSyuuseiModal()
    }

    // ダイアログ：キャンセル
    const canceldFuyoSyuusei = async () => {
      fuyoSyuuseiModal.closeFuyoSyuuseiModal()
    }

    // ダイアログ：クローズ
    const closedFuyoSyuusei = async () => {
      fuyoSyuuseiModal.closeFuyoSyuuseiModal()

      let start = dayjs(selectedPeriod.value).format('YYYY/MM/DD')
      let end = dayjs(selectedPeriod.value).add(1, 'y').subtract(1, 'd').format('YYYY/MM/DD')

      // 選択年月の台帳情報を取得
      daichouInfo.value = await getPastDaichouInfo(userId.value, start, end);

      const info = daichouInfo.value
      fuyoDate.value = info.this_year_fuyo_date
        if(!fuyoDate.value){
          return
        }
        const period = getPeriod(fuyoDate.value)

        // 有給休暇リスト
        syutokuList.value = await getKyukaList(code, period.start, period.end, info.konnen_fuyo_days, info.zennen_kurikoshi_days, info.tokubetsu_kyuuka);

        userId.value = info.user_id
    }

    // 翌年度有給付与日数
    const yokunenFuyoDays = computed(() => {
      if(!daichouInfo.value?.konnen_fuyo_days){
        return null
      }
      return daichouInfo.value.konnen_fuyo_days < 20 ? daichouInfo.value.konnen_fuyo_days + 1 : 20
    })

    const getPeriod = (fuyo: string | null) =>{
      if(!fuyo){
        return { start: null, end: null }
      }
      const start = dayjs(fuyo).format('YYYY/MM/DD')
      const end = dayjs(fuyo).add(1, 'y').subtract(1, 'd').format('YYYY/MM/DD')

      return { start: start, end: end }
    }

    const deleteYuukyuuShinsei = async (index: number) => {
      const row = syutokuList.value[index]

      let messageList = ["<div><p class='title'>取得日</p><p class='item'>" + row.yuukyuu_syutoku_date + "</p></div>",
                         "<div><p class='title'>取得区分</p><p class='item'>" + row.yuukyuu_tani_type_str + "</p></div>"]
      const message = "<div class='content'>" + messageList.join('') + "</div>"
      DialogService.warning({
        title: "有給削除",
        html : "<p>この有給を取り消しますか？</p>" + message,
        showCancelButton: true,
        confirmButtonText: "取り消し",
        cancelButtonText: "キャンセル",
        customClass:{
          htmlContainer: 'yuukyuu-kanri'
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          // 有給削除
          const res = await deleteYuukyuu(row)
          if(!res){
            return
          }
          // 有給再読み込み
          const period = getPeriod(daichouInfo.value.this_year_fuyo_date)
          syutokuList.value = await getKyukaList(code, period.start, period.end, daichouInfo.value.konnen_fuyo_days, daichouInfo.value.zennen_kurikoshi_days, daichouInfo.value.tokubetsu_kyuuka)
        }
      })
    }

    // フィルタ変数
    const filter = ref('');

    // 選択した付与日の有給情報を表示する
    const changeFuyobi = async () => {

      if (!selectedPeriod.value || selectedPeriod.value == undefined) {
        return;
      }

      if (options.value.length == 0) {
        return;
      }

      let tmp = options.value.filter((v: any) => v.val == selectedPeriod.value);

      //  今年度付与数の編集ボタン表示・非表示の設定
      if (tmp[0].code == '1') {
        disableFlg.value = false;
      } else {
        disableFlg.value = true;
      }

      let start = dayjs(selectedPeriod.value).format('YYYY/MM/DD')
      let end = dayjs(selectedPeriod.value).add(1, 'y').subtract(1, 'd').format('YYYY/MM/DD')

      daichouInfo.value = await getPastDaichouInfo(userId.value, start, end);

      // 有給休暇リスト取得
      syutokuList.value = await getKyukaList(code, start, end, daichouInfo.value.konnen_fuyo_days, daichouInfo.value.zennen_kurikoshi_days, daichouInfo.value.tokubetsu_kyuuka);
    };

    // 新規作成画面へ遷移
    const toNew = (() => {

      if (userId.value) {
        router.push({ name: RouterConst.YUUKYUU_KANRI_CREATE, params: { id: userId.value } });
      }

    });

    return {
      isLoading,
      isListLoading,
      syutokuList,
      daichouInfo,
      "koyouKeitaiType": OptionConst.KOYOU_KEITAI_TYPE_OPTION,
      dateFormat,
      RouterConst,
      editFuyoDays,
      isFuyo,
      canceldFuyoSyuusei,
      closedFuyoSyuusei,
      openFuyoSyuuseiDialog,
      fuyoSyuuseiModalRef: fuyoSyuuseiModal.fuyoSyuuseiModalRef,
      fuyoSyuuseiModalParts: fuyoSyuuseiModal.fuyoSyuuseiModalParts,
      syuuseiData: fuyoSyuuseiModal.syuuseiData,
      userId,
      yokunenFuyoDays,
      deleteYuukyuuShinsei,
      router,
      isInitLoading,
      getFuyobiOptions,
      options,
      selectedPeriod,
      changeFuyobi,
      disableFlg,
      filter,
      toNew,
    };
  },
  components: {
    'dialog-fuyo-syuusei': FuyoSyuusei,
  },
});
</script>

<style lang="scss" scoped>
@import '@scss/components/yuukyuu-detail.scss';
</style>
